import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography, Stack, TextField, InputAdornment, Button, FormControl, Select, MenuItem } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import PersonAddRoundedIcon from "@mui/icons-material/PersonAddRounded";
import GroupMoveRoundedIcon from "@mui/icons-material/MoveDownRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import KeyRoundedIcon from "@mui/icons-material/KeyRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import PersonAddAlt1RoundedIcon from "@mui/icons-material/PersonAddAlt1Rounded";
import { isEmpty } from "lodash";
import SmallModal from "../../../components/modals/SmallModal";

import Swal from "sweetalert2";
import { DataContext } from "../../../context/DataContext";
import { deleteToken, deleteUserData, getToken } from "../../../api/Account";
import { getRuta, isAccess, simpleMessage } from "../../../helpers/Helpers";
import { deleteUserAsync, getAllUserAsync, getInactiveUserListAsync, getUserListAsync, reactivateUserAsync, resetUserPasswordAsync } from "../../../api/Users";
import NoData from "../../../components/NoData";
import { PaginationComponent } from "../../../components/PaginationComponent";
import MigrateWallet from "./MigrateWallet";
import StatusChip from "../../../components/ui/StatusChip";
import { monoFont } from "../../../theme";

const initials = (fullName) => {
  const parts = (fullName || "").trim().split(/\s+/);
  return `${(parts[0] || "")[0] || ""}${(parts[1] || "")[0] || ""}`.toUpperCase();
};

const Userlist = () => {
  const [userList, setUserList] = useState([]);

  const [localReload, setLocalReload] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { setIsLoading, setIsLogged, setIsUnautorized, access } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  const [active, setActive] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");

  const withSearch = userList.filter((val) => {
    if (searchTerm === "") {
      return val;
    } else if (val.id.toString().includes(searchTerm) || val.fullName.toString().includes(searchTerm) || val.userName.toString().includes(searchTerm.toLocaleLowerCase())) {
      return val;
    }
    return false;
  });

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      let result = [];
      if (active === 0) {
        result = await getUserListAsync(token);
      }

      if (active === 1) {
        result = await getInactiveUserListAsync(token);
      }

      if (active === 2) {
        result = await getAllUserAsync(token);
      }

      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setUserList(result.data.result);
    })();
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = withSearch.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const deleteUser = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "No podras revertir esto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Eliminar!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await deleteUserAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Eliminado!", "Usuario Eliminado.", "success");
        })();
      }
    });
  };

  const reactivateUser = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "Darás acceso al sistema a este usuario...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Proceder!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await reactivateUserAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Reactivado!", "Usuario activado.", "success");
        })();
      }
    });
  };

  const onChangeSearch = (val) => {
    setCurrentPage(1);
    setSearchTerm(val);
    paginate(1);
  };

  const onSelectChange = async (value) => {
    setActive(value);
    setIsLoading(true);
    let result = [];
    if (value === 0) {
      result = await getUserListAsync(token);
    }

    if (value === 1) {
      result = await getInactiveUserListAsync(token);
    }

    if (value === 2) {
      result = await getAllUserAsync(token);
    }

    if (!result.statusResponse) {
      if (result.error === "eX01") {
        setIsLoading(false);
        deleteUserData();
        deleteToken();
        setIsLogged(false);
        return;
      }
      setIsLoading(false);
      if (result.error === "Unauthorized") {
        setIsUnautorized(true);
        return;
      }
      simpleMessage(result.error, "error");
      return;
    }

    setIsLoading(false);
    setUserList(result.data.result);
  };

  const resetPassword = async (item) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "Se estableceras la contraseña por defecto...!",
      icon: "warning",
      showCancelButton: true,

      confirmButtonColor: "#2979ff",
      cancelButtonColor: "#f50057",

      confirmButtonText: "Proceder!",
      cancelButtonText: "Cancelar",
      customClass: {
        popup: "border",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        (async () => {
          setIsLoading(true);
          const result = await resetUserPasswordAsync(token, item.id);
          if (!result.statusResponse) {
            setIsLoading(false);
            if (result.error === "Unauthorized") {
              setIsUnautorized(true);
              return;
            }
            simpleMessage(result.error, "error");
            return;
          }
          if (result.error === "eX01") {
            setIsLoading(false);
            deleteUserData();
            deleteToken();
            setIsLogged(false);
            return;
          }
          setIsLoading(false);
          setLocalReload(!localReload);
          Swal.fire("Contrseña Reseteada!", "Nueva Contraseña es 123456.", "success");
        })();
      }
    });
  };

  return (
    <div>
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ xs: "stretch", sm: "center" }} spacing={1.5} flexWrap="wrap" sx={{ marginBottom: "18px" }}>
        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} alignItems={{ xs: "stretch", sm: "center" }}>
          <TextField
            size="small"
            onChange={(e) => onChangeSearch(e.target.value.toUpperCase())}
            value={searchTerm}
            placeholder="Buscar usuario..."
            sx={{ width: { xs: "100%", sm: 260 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchRoundedIcon sx={{ fontSize: 19, color: "text.disabled" }} />
                </InputAdornment>
              ),
            }}
          />
          <FormControl size="small" sx={{ minWidth: 140 }}>
            <Select onChange={(e) => onSelectChange(e.target.value)} value={active}>
              <MenuItem value={0}>Activos</MenuItem>
              <MenuItem value={1}>Inactivos</MenuItem>
              <MenuItem value={2}>Todos</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
          {isAccess(access, "MIGRAR CARTERA") ? (
            <Button onClick={() => setShowModal(true)} startIcon={<GroupMoveRoundedIcon />} variant="outlined" color="warning">
              Migrar cartera
            </Button>
          ) : null}

          {isAccess(access, "SECURITY CREATE") ? (
            <Button onClick={() => navigate(`${ruta}/adduser`)} startIcon={<PersonAddRoundedIcon />} variant="contained" color="primary" sx={{ whiteSpace: "nowrap" }}>
              Agregar usuario
            </Button>
          ) : null}
        </Stack>
      </Stack>

      {isEmpty(currentItem) ? (
        <NoData />
      ) : (
        <Paper sx={{ overflow: "hidden" }}>
          <TableContainer sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 780 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontFamily: monoFont }}>Usuario</TableCell>
                  <TableCell>Nombre completo</TableCell>
                  <TableCell align="center">Teléfono</TableCell>
                  <TableCell>Rol</TableCell>
                  <TableCell align="center">Estado</TableCell>
                  {isAccess(access, "SECURITY UPDATE") || isAccess(access, "SECURITY DELETE") ? <TableCell align="center">Acciones</TableCell> : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {currentItem.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell sx={{ fontFamily: monoFont, fontSize: 12.5, color: "success.main", fontWeight: 500 }}>{row.userName}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1.2} alignItems="center">
                        <Box
                          sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "8px",
                            backgroundColor: "action.hover",
                            color: "text.secondary",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 11.5,
                            fontWeight: 600,
                            flexShrink: 0,
                          }}
                        >
                          {initials(row.fullName)}
                        </Box>
                        <Typography sx={{ fontSize: 13, fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{row.fullName}</Typography>
                      </Stack>
                    </TableCell>
                    <TableCell align="center" sx={{ fontFamily: monoFont, fontSize: 12.5 }}>
                      {row.phone}
                    </TableCell>
                    <TableCell sx={{ fontSize: 12.5, fontWeight: 500 }}>{row.userRol.rolName}</TableCell>
                    <TableCell align="center">
                      <StatusChip label={row.isActive ? "Activo" : "Inactivo"} tone={row.isActive ? "success" : "neutral"} />
                    </TableCell>
                    {isAccess(access, "SECURITY UPDATE") || isAccess(access, "SECURITY DELETE") ? (
                      <TableCell align="center">
                        <Stack direction={"row"} spacing={0.3} justifyContent="center">
                          {isAccess(access, "SECURITY UPDATE") ? (
                            <IconButton size="small" onClick={() => navigate(`${ruta}/user/${row.id}`)} title="Ver">
                              <OpenInNewRoundedIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          ) : null}
                          {isAccess(access, "SECURITY UPDATE") && row.isActive ? (
                            <IconButton size="small" sx={{ color: "warning.main" }} onClick={() => resetPassword(row)} title="Restablecer contraseña">
                              <KeyRoundedIcon sx={{ fontSize: 17 }} />
                            </IconButton>
                          ) : null}

                          {isAccess(access, "SECURITY DELETE") ? (
                            <IconButton
                              size="small"
                              sx={{ color: "error.main" }}
                              onClick={() => (row.isActive ? deleteUser(row) : reactivateUser(row))}
                              title={row.isActive ? "Eliminar" : "Reactivar"}
                            >
                              {row.isActive ? <DeleteRoundedIcon sx={{ fontSize: 17 }} /> : <PersonAddAlt1RoundedIcon sx={{ fontSize: 17 }} />}
                            </IconButton>
                          ) : null}
                        </Stack>
                      </TableCell>
                    ) : null}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ padding: "10px 20px 14px" }}>
            <PaginationComponent data={withSearch} paginate={paginate} itemsperPage={itemsperPage} />
          </Box>
        </Paper>
      )}

      <SmallModal titulo={"Migrar Cartera"} isVisible={showModal} setVisible={setShowModal}>
        <MigrateWallet setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} />
      </SmallModal>
    </div>
  );
};

export default Userlist;
